module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"content":"Content"},"de":{"content":"Inhalt"}}')
  delete Component.options._Ctor
}
